import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

// import Configurer from "../../components/Configurer";
import StagesManager from "../../components/StagesManager";
import { checkDefaultTab, checkTranslation, conditionalWidth, imageAddress, pathMaker, translate } from "../../utils/useful";
import Cookies from "universal-cookie";
import PageStatusViewer from "../../components/PageStatusViewer";

// import AdminDashboard from "../admin/AdminDashboard";
// import AdminFormApplet from "../admin/AdminFormApplet";
// import AdminBoxesApplet from "../admin/AdminBoxesApplet";
import { CommerceUserPages } from "../../variables/AppletPages";
// import AppletDashboardView from "./views/AppletDashboardView";
// import { Link } from "react-router-dom";
// import TLink from "../../components/TLink";
// import AdminSettings from "../admin/AdminSettings";

// import BoxesView from "../../components/views/BoxesView";
// import FormView from "../../components/views/FormView";
// import DashboardView from "../../components/views/DashboardView";
// import SettingsView from "../../components/views/SettingsView";
// import Responsive from "../../components/Responsive";
// import Collapsible from "react-collapsible";
// import Warehouse from '../../components/views/Warehouse';
import ProductsView from './ProductsView';
import CommerceCart from './CommerceCart';
import SingleProduct from './SingleProduct';
import ShopAccount from './ShopAccount';
// import PaymentFirst from './CartDelivery';
// import AddressPage from './AddressPage';
// import PreviousOrders from './PreviousOrders';
// import VoucherPage from './VoucherPage';
// import PreviousPayments from './PreviousPayments';
// import WishLists from './WishLists';
import Payment from './CartPayment';
import Header from '../../components/header/Header';
import HttpServices from '../../utils/Http.services';
import CollectionView from './database/CollectionView';
// import PageViewer from '../PageViewer';
import CartDelivery from './CartDelivery';
import CartPayment from './CartPayment';
// export default class CommerceAdminView extends Component {
class CommerceUserView extends React.Component {

    state = {
        module: [{
            name: "{{lang}}products",
            icon: "/images/icons/chart.svg",
            key: "",
            dontShowInDashboard: true,
        },
        {
            name: "{{lang}}single product",
            icon: "/images/icons/play-cricle.svg",
            key: "product",
        },
        {
            name: "{{lang}}account",
            icon: "/images/icons/save-2.svg",
            key: "account",
        },
        {
            name: "{{lang}}Shopping Cart",
            icon: "/images/icons/notification.svg",
            key: "cart",
        },


            //   {
            //     name: "{{lang}}connections",
            //     icon: "/images/icons/message.svg",
            //     key: "connections",
            //   },
            //   {
            //     name: "{{lang}}Exercises-tests-and-notes",
            //     icon: "/images/icons/clipboard-text.svg",
            //     key: "homework",
            //   },
            //   {
            //     name: "{{lang}}Course-files",
            //     icon: "/images/icons/folder-2.svg",
            //     key: "files",
            //   },
            //   {
            //     name: "{{lang}}profile",
            //     icon: "/images/icons/user.svg",
            //     key: "profile",
            //   },
            // {
            //   name: "امتحان ها",
            //   icon: "/images/icons/user.svg",
            //   key: "quiz",
            // },
        ],

        headerConfig: {
            showCart: true
        },
        myProducts: [],
        myCategories: [],

        collapses: {},
        showBackBtn: false,
        showToolbar: false,
        bg: 'linear-gradient(90deg, #184D94, #246AC7)',
        bg2: 'rgba(37, 91, 0, 0.1)',

    }


    componentDidMount() {

        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

    }



    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                let accessPages = Object.values(CommerceUserPages.pages)
                let accessSections = Object.values(CommerceUserPages.sections)
                // console.log(accessPages)
                this.setState({ modules: accessPages, sections: accessSections }, () => {
                    this.checkDefaultTab()
                    // this.getCart()
                    this.fetchMyProducts()
                    this.fetchMyCategories()

                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(prevProps) {
        // console.log('componentDidUpdate');
        // // let windowPath = this.props.windowData//.split('/')
        // // windowPath = windowPath[windowPath.length - 1]

        // console.log(this.state.oldData)
        // console.log(this.props.windowData)
        // console.log(JSON.stringify(this.state.oldData))
        // console.log(JSON.stringify(this.props.windowData))

        if ((this.state.oldData && JSON.stringify(this.state.oldData) != JSON.stringify(this.props.windowData))) {
            // console.log('componentDidUpdate 1');
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }
    }



    checkDefaultTab() {

        checkDefaultTab(this.props.windowData, this.props.baseUrl, this.state.modules, this.props.width, (pageInfo, pageType, def) => {

            def = def ?? ''
            pageType = pageType != null ? pageType : def


            if (pageType != null) {

                this.setState({ oldData: this.props.windowData, path: def, pageType: pageType, page: null }, () => {

                    setTimeout(() => {
                        this.setState({ page: pageInfo, pageType, pageStatus: 200 }, () => {
                            if (this.stageManager) {
                                this.stageManager.changeStage((pageType), () => { })
                            }
                        })
                    }, 10);
                })
            } else {
                this.setState({ pageStatus: 404 })
            }

        })
    }



    // checkDefaultTab() {


    //     // console.log("checkDefaultTab")
    //     let def = ''
    //     let pageType = null
    //     let pageInfo = null
    //     let pathname = this.props.windowData.path//window.location.pathname.split('/')
    //     // console.log(this.props.windowData);
    //     let rootRef = this.props.baseUrl.split('/')
    //     // console.log(this.props.route);
    //     rootRef = rootRef[rootRef.length - 1]
    //     pathname.forEach((path, index) => {
    //         if (path == (rootRef)) {
    //             def = pathname[index + 1]
    //         }
    //     });


    //     if (!def) {
    //         def = ''
    //     }
    //     // console.log(this.props.route)


    //     let pageIsValid = false
    //     // let accessPages = Object.values(SettingsPages.pages)

    //     Object.values(this.state.module).forEach(page => {

    //         let defaultPage = page.defaultPage
    //         if (conditionalWidth(this.props.width, { xs: true, sm: false })) {
    //             defaultPage = false
    //         }
    //         console.log(def)
    //         // return
    //         // console.log(((def==''|| !def) && page.defaultPage))
    //         if ((((def == '' || !def) && defaultPage) || (page.key && page.key.toLowerCase() === def?.toLowerCase()))) {
    //             pageIsValid = true
    //             pageType = page.key
    //             // console.log(page)
    //             pageInfo = page

    //             if ((def == '' || !def)) {
    //                 def = page?.key
    //                 this.changePage(page?.key)
    //             }
    //         }

    //     });
    //     // if (!def) {
    //     //     def = ''
    //     // }



    //     // return
    //     // console.log(def)
    //     // return
    //     if (def === '') {
    //         pageType = ''
    //         pageIsValid = true
    //         // this.changePage('general')

    //     }
    //     if (pageIsValid) {

    //         // this.state.page = page
    //         // console.log(pageType)

    //         this.setState({ oldData: this.props.windowData }, () => {


    //             this.setState({ path: def, pageType }, () => {
    //                 // console.log(pageType) 


    //                 setTimeout(() => {
    //                     this.setState({ page: null }, () => {

    //                         this.setState({ page: pageInfo, pageType, pageStatus: 200 }, () => {
    //                             if (this.stageManager) {
    //                                 this.stageManager.changeStage((pageType), () => {
    //                                     // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
    //                                 })
    //                             } else {

    //                             }
    //                         })
    //                     })
    //                 }, 10);
    //             })

    //         })
    //     } else {
    //         this.setState({ pageStatus: 404 })
    //     }

    // }



    changeWindowLink = (page) => {
        // console.log('first', page)
        let path
        if (page) {
            if (Array.isArray(page)) {
                path = page

            } else {
                path = [page?.key ?? page]
            }
        }
        // console.log(path)
        this.props.changeWindowLink(path)

    }




    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }




    backStage = () => {


        this.stageManager.lastStage((stage) => {

            let showToolbar = false
            let shouldHaveToolbar = ['', 0]
            if (shouldHaveToolbar.includes(stage)) {
                showToolbar = true
            }


            let showBackBtn = true
            let shouldHaveBackBtn = ['', 0]
            if (shouldHaveBackBtn.includes(stage)) {
                showBackBtn = false
            }

            this.setState({ showToolbar, showBackBtn })

        })
    }


    changePage = (page) => {
        let fullPath = [...this.props.baseUrl]

        let newLink = Array.isArray(page) ? page : [page]
        fullPath = [...fullPath, ...newLink]

        this.changeWindow(fullPath)

    }


    changeWindow = (list) => {

        // console.log("changeWindow")
        // console.log(list)

        if (Array.isArray(list)) {

            let finalList = []
            list.forEach(value => {
                let one = value
                if (/\{\{(.*?)\}\}/.test(value)) {

                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
                if (one) {
                    finalList.push(one)
                }
            });
            // console.log('pppppppppppp11',finalList);
            this.props.changeWindow('applet', { type: 'applet', path: finalList })
        }
    }

    // addToCart = (changeCount) => {
    //     // console.log('first')
    //     this.setState({ isLoadingData: true })
    //     HttpServices.request('addToCart', { products: this.state.product, changeCount: changeCount }, (fetchResult, fetchError, fetchStatus) => {
    //         this.setState({ isLoadingData: false })

    //         if (fetchError) {
    //             console.log('fetchError', fetchError)
    //             return
    //         }
    //         // console.log('My product', fetchResult.info)
    //         this.setState({ cart: fetchResult.newCart }, () => {
    //             this.checkCart()
    //         })
    //     })
    // }



    functionsHandler = (type, name, data) => {

        if (type) {
            if (this[type] && this[type][name]) {
                this[type][name](data)
            }
        } else {
            if (this[name]) {
                this[name](data)
            }
        }
    }


    setHeader = (key, value) => {


        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showCart: true,
                    cart: this.state.headerConfig.cart,
                    showToolbar: true,
                    topHeaderComponent: null,
                    backAction: null,
                    showSettings: "commerceUser"

                }
                // this.state.headerConfig = { showToolbar: true, topHeaderComponent: null, backAction: null }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }


                this.setState({ headerConfig: object }, () => {
                    // console.log(this.state.headerConfig)
                    this.header.forceUpdate()
                })
            }

            else {
                // console.log("setHeader")
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }
    fetchMyProducts = () => {
        this.setState({ isLoadingData: true })
        HttpServices.request('getProducts', {}, (fetchResult, fetchError, fetchStatus) => {
            // console.log(fetchResult.info, 'getProducts')
            this.setState({ isLoadingData: false })

            if (fetchError) {
                // console.log('fetchError', fetchError)
                return
            }
            // console.log('My product', fetchResult.info)
            this.setState({ myProducts: fetchResult.info })
        })
    }
    fetchMyCategories = () => {

        let body = {
            applet: this.props.variables?.appletId,
            appletHub: this.props.variables?.appletHub,

        }
        // console.log(body, 'body=====')
        HttpServices.request("getProductsCategories", body, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log("fetchError", fetchError)
                return
            }
            // console.log("my categories", fetchResult)
            this.setState({ myCategories: fetchResult.info })
        })
    }
    // changeCollapse = (key) => {
    //     let collapses = this.state.collapses
    //     collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
    //     this.setState({ collapses })
    // }
    render() {
        let appletHub = typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub?._id : this.props.applet?.hub
        let variables = {
            applet: this.props.applet,
            appletId: this.props.applet?._id,
            appletHub: appletHub
        }

        return (
            <div className='d-flex w-100 h-100 window-content-radius ' style={{ display: 'block', backgroundColor: '#fff' }}>

                <div className="w-100  h-100  window-content-radius d-flex flex-column " ref={el => this.pageContainer = el} style={{}} >

                    <div style={{ position: 'relative', top: 0 }}>
                        {/* <Header data={{ cart: this.state.cart, totalCount: this.state.totalCount, totalPrice: this.state.totalPrice }} shoppingCard={true} type={'inquery'} language={this.props.language} types={'commerce'} toolbarView={'applet'} headertype={'applet'} changeWindow={this.changePage} currentFrame={this.state.currentFrame} list={this.state.list} goToHub={this.props.goToHub} backStage={this.backStage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} color={this.state.bg} color2={this.state.bg2} toolbar={this.state.showToolbar} addNewForm={this.addNewForm} /> */}
                        <Header ref={el => this.header = el} config={this.state.headerConfig} cart={this.state.cart} addToCart={this.addToCart} variables={variables} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} />

                    </div>

                    {/* <Responsive width={this.props.width} height="100%" media={{ xs: "12" }}>

                    <div className="w-100 h-100  " ref={el => this.pageContainer = el} style={{ backgroundColor: '#fff' ,position:'relative'}} > */}
                    <StagesManager ref={el => this.stageManager = el} fast={true} height={'0px'} className={'flex-1'}>

                        {/* <PageViewer stageName={''} editMode={false} functionsHandler={this.props.functionsHandler} setHeader={this.props.setHeader}
                            params={this.state.params} initData={this.state.initData} width={this.props.width} height={this.props.height} colors={this.props.colors} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage}
                            windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                            connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                            addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                            goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow}
                        /> */}


                        <ProductsView stageName={''} myCategories={this.state.myCategories} myProducts={this.state.myProducts} cart={this.state.cart} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} stage={1} onClick={this.changePage} user={this.props.user} modules={this.state.modules} changeWindowLink={this.changeWindowLink} route={this.props.route} variables={variables} />
                        <SingleProduct stageName={'product'} config={this.state.headerConfig} myCategories={this.state.myCategories} myProducts={this.state.myProducts} cart={this.state.cart} getCart={this.getCart} addToCart={this.addToCart} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} />
                        <CollectionView ref={el => this.collectionView = el} stageName={'collection'} myCategories={this.state.myCategories} myProducts={this.state.myProducts} cart={this.state.cart} setHeader={this.setHeader} page={this.state.page} colors={this.props.colors} width={this.props.width} height={this.props.height} formPages={this.state.formPages} baseUrl={[...this.props.baseUrl]} applet={this.props.applet} headers={this.state.headers} automations={this.state.automations} language={this.props.language} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} goToHub={this.props.goToHub} variables={variables} />

                        <ShopAccount stageName={'settings'} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} />
                        {/* <PreviousOrders stageName={'orders'} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} /> */}
                        {/* <VoucherPage stageName={'vouchers'} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} /> */}
                        {/* <AddressPage stageName={'addresses'} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} /> */}
                        {/* <PreviousPayments stageName={'payments'} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} /> */}
                        {/* <WishLists stageName={'whishlist'} myProducts={this.state.myProducts} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} /> */}

                        <CommerceCart stageName={'cart'} language={this.props.language} getCart={this.getCart} addToCart={this.addToCart} cart={this.state.cart} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} />

                        {/*        <CommerceCart stageName={'cart'} language={this.props.language} getCart={this.getCart} addToCart={this.addToCart} cart={this.state.cart} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} />
                        <CartDelivery stageName={'delivery'} language={this.props.language} windowData={this.props.windowData} cart={this.state.cart} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} />
                        <CartPayment stageName={'payment'} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} /> */}

                    </StagesManager>
                </div>
                {/* </div>

                </Responsive> */}
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommerceUserView);